import { createFileRoute, redirect } from '@tanstack/react-router';

import { redirectToVehicles } from './-redirect';

// Legacy path, kept only so old bookmarks/links to the pre-rename list still resolve.
export const Route = createFileRoute('/_app/fleet-management/digital-vehicle-files/')({
  beforeLoad: ({ location }) => {
    throw redirect(redirectToVehicles(location.href));
  },
});
